var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 5.66699H14.6668M1.3335 5.66699V13.0005C1.3335 13.9339 1.3335 14.4004 1.51515 14.7569C1.67494 15.0705 1.92972 15.3257 2.24333 15.4855C2.5995 15.667 3.06599 15.667 3.99759 15.667H12.0027C12.9343 15.667 13.4002 15.667 13.7563 15.4855C14.0699 15.3257 14.3256 15.0705 14.4854 14.7569C14.6668 14.4007 14.6668 13.9349 14.6668 13.0033V5.66699M1.3335 5.66699V5.00049C1.3335 4.06707 1.3335 3.60001 1.51515 3.24349C1.67494 2.92989 1.92972 2.6751 2.24333 2.51531C2.59985 2.33366 3.0669 2.33366 4.00033 2.33366H4.66683M14.6668 5.66699V4.99775C14.6668 4.06615 14.6668 3.59966 14.4854 3.24349C14.3256 2.92989 14.0699 2.6751 13.7563 2.51531C13.3998 2.33366 12.9337 2.33366 12.0003 2.33366H11.3335M4.66683 2.33366H11.3335M4.66683 2.33366V0.666992M11.3335 2.33366V0.666992M10.0835 10.667H5.91683",
    stroke: "#E37461",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.dae178c7b0b81d4bcfa34cffc2a026ab.svg";
export { ForwardRef as ReactComponent };